import FuneralQuickQuote from './FuneralQuickQuote'

export default FuneralQuickQuote
